export const lightText = "#ffffff";
export const medText = "#686868";

export const darkGrey = "#58595b";
export const medDarkGrey = "#888888";
export const medGrey = "#bcbec0";
export const lightGrey = "#e6e7e8";
export const lighterGrey = "#eff0f1";
export const lightestGrey = "#f8f8f8";
export const transparentBlue = "#0ba6d617";
export const medBlue = "#4177b7";
export const darkBlue = "#182E58";
export const blueButton = "#306992";
export const lightBlueButton = "#4BA3D1";
export const blueNotification = "#9fcdee";

export const flightBackgroundColor = "#efefef";
export const cardBorder = "#dedede";
export const cardBorderLightBackground = "#dadbde";
export const unknownAdjustmentColor = "#2575ca";

export const goodColor = "#39b54A";
export const watchColor = "#fecb45";
export const alertColor = "#ff3333";
export const textOnGood = "#ffffff";
export const textOnWatch = "#414042";
export const textOnAlert = "#ffffff";
export const warningText = "#ff53cf";

export const muiButtonText = "rgba(0,0,0,0.87)";

export const producingColor = "#39b54a";
export const qualityLossColor = "#cdecd1";
export const speedGainColor = "#009900";
export const darkGreen = "#006400"; // use this when we need more contrast against producingColor
export const speedColor = "#f95700";
export const plannedColor = "#0ca6d6";
export const changeoverColor = "#6dcae6";
export const waitingColor = "#fcf122";
export const unplannedColor = "#ff9933";
export const untaggedColor = "#ff3333";
export const noProductionScheduledColor = "#999999";
export const plantLossColor = "#999999";
export const uncollectedColor = "#eaeaea";

export const plannedTagColor = "#1C75BC";
export const unplannedTagColor = "#FF9933";
export const waitingTagColor = "#FECB45";
export const notScheduledTagColor = "#414042";

export const textOnProducing = "#ffffff";
export const textOnSpeedLoss = "#ffffff";
export const textOnPlanned = "#ffffff";
export const textOnWaiting = "#414042";
export const textOnUnplanned = "#414042";
export const textOnUnknown = "#ffffff";
export const textOnNotScheduled = "#ffffff";
export const textOnPlant = "#ffffff";
export const textOnUncollected = "#414042";

export const highlight = "#ea4335";
export const highlightOnBlack = "rgba(255,140,140, 1)";
export const buttonTextDisabled = "#b1b1b1";
export const buttonDisabled = "#e0e0e0";

export const trendChartTargetLineColor = "#424242";

export const darkModeTextColor = "#EEEEEE";
export const darkModeLinkColor = "#0BA6D6";
export const darkModeDarkTextColor = "#AAAAAA";
export const darkModeDisabledTextColor = "#888888";
export const darkModeBackgroundColor = "#222222";
export const darkModeBackgroundHoveredColor = "#272727";
export const darkModeBackgroundHoveredTransparentColor =
  "rgba(39, 39, 39, 0.4)";
export const darkModeCardBackgroundColor = "#2D2D2D";
export const darkModeCardBackgroundColorRGBA = "rgba(45,45,45, 1)";
export const darkModeCardBorderColor = "#505050";
export const darkModeElementBorderColor = "#C4C4C4";
export const darkModeTitleBackgroundColor = "#535353";
export const darkModeModalBackgroundColor = "#393939";
export const darkModeTabIndicatorColor = "#8E8E8E";

export const operatorSegmentColor = "#D1D5DE";
export const skuSegmentColor = "#74829B";
export const skuSegmentColorTransparent = "#74829B88";
export const placeholderTextColor = "#8E8E8E";

export const flDanger60 = "#ECD2D2";
export const flDangerBorder = "#CF6B6B";
export const flSuccess60 = "#CAE5C8";
export const flSuccessBorder = "#8EB88A";
export const flGeneral60 = "#D4E2F0";
export const flGeneralBorder = "#7EA4C7";
export const flWarning60 = "#ECE6C3";
export const flWarningBorder = "#CCBF71";

export const lightTextPlaceholder = "#8B8C8E";
export const lightTextSubheading = "#626364";
export const darkTextPlaceholder = "#7D7E80";
export const darkPnlProducing100 = "#39B54A";
export const darkPnlProducing110 = "#287F34";
export const lightSurface1 = "#FDFDFF";
export const lightSurface2 = "#F6F6F8";
export const lightSurface3 = "#EDEDEF";
export const lightNeutral50 = "#C7C8CB";
export const lightTextBody = "#373738";

export const lightAccentSuccess10 = "#F1FFF0";
export const lightAccentSuccess50 = "#7DB877";
export const lightAccentSuccess90 = "#2B5927";
export const darkNeutral10 = "#F6F7F9";
export const brandPrimary70 = "#416CE2";
export const brandPrimary90 = "#26469E";
export const lightNeutral10 = "#F6F6F8";
export const lightNeutral60 = "#B6B7BA";
export const lightNeutral70 = "#8B8C8E";
export const lightNeutral100 = "#0C0C0D";
export const lightBorder1 = "#DADBDE";
export const lightBorder3 = "#B6B7BA";
export const lightTextOnDark = "#FDFDFF";
export const lightTextLink = "#0087C1";

export const lightBlueActive = "rgba(65, 108, 226, 0.1)";
export const lightBlueActiveDarkMode = "rgba(65, 108, 226, 0.5)";
export const lighterBlueActive = "rgba(65, 108, 226, 0.06)";

export const brightBlue = brandPrimary70;
export const primaryBrightBlue = brandPrimary70;
